import { render, staticRenderFns } from "./LinhaProdutoManage.vue?vue&type=template&id=b522b53c&scoped=true"
import script from "./LinhaProdutoManage.vue?vue&type=script&lang=js"
export * from "./LinhaProdutoManage.vue?vue&type=script&lang=js"
import style0 from "./LinhaProdutoManage.vue?vue&type=style&index=0&id=b522b53c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b522b53c",
  null
  
)

export default component.exports